import { Injectable } from '@angular/core';
import { brandColorStyles, brandSpecificStyles, brandLogoStyles } from '../constants/BrandStylingConstants';
import { environment } from '../../environments/environment';
import { JllBranding } from "../constants/Branding";

@Injectable()
export class BrandingService {

  constructor() { }

  initializeBrandingMode(brandingInfo) {
    this.removeBrandingStyles();
    if(brandingInfo) {
      this.addBrandingClass(brandingInfo);
    } else {
      this.toggleNoBrandMode(false);
    }
  }

  addBrandingClass(brandData) {
    if(brandData) {
      document.getElementsByTagName('BODY')[0].classList.add('brand-active');
      this.overrideBrandingStyles(brandData);
      (<any>window).branding.addMapsBrandingStyles(brandData);
      setTimeout(()=>{
        this.toggleNoBrandMode(false);
      },0);
    }
  }

  overrideBrandingStyles(brandData) {
    let w = (<any>window);

    let overrideBrandTheme = document.createElement('style');
    overrideBrandTheme.id = 'brand-theme-css';
    overrideBrandTheme.type = 'text/css';
    overrideBrandTheme.innerHTML = this.calculateBrandStyles(brandData);
    document.getElementsByTagName('head')[0].appendChild(overrideBrandTheme);
  }

  calculateBrandStyles(brandData) {
    return brandColorStyles().replace(new RegExp('@brandThemeColor@', 'g'), brandData.colorHex) + brandSpecificStyles(brandData.brandingKey).replace(new RegExp('@brandThemeColor@', 'g'), brandData.colorHex) + brandLogoStyles().replace(new RegExp('@brandThemeLogo@', 'g'), brandData.logoUrl);
  }

  removeBrandingStyles() {
    let w = (<any>window);
    document.getElementsByTagName('BODY')[0].classList.remove('brand-active');
    document.getElementById('brand-theme-css') && document.getElementById('brand-theme-css').remove();
    this.toggleNoBrandMode(true);
    w.branding.removeMapsBrandingStyles();
  }

  toggleNoBrandMode(toggle) {
    if(toggle) {
      document.getElementsByTagName('BODY')[0].classList.add('no-brand-mode');
    } else {
      document.getElementsByTagName('BODY')[0].classList.remove('no-brand-mode');
    }
  }

  //JLL
  isJllSite() {
    return (<any>window).location.hostname === environment.APP.JLL.HOSTNAME;
  }

  addJllSiteBrandingClass() {
    if(this.isJllSite()) {
      document.getElementsByTagName('BODY')[0].classList.add('jll-site-brand-active');
    }
  }

  checkAndApplyJllStyles() {
    this.initializeBrandingMode(this.isJllSite()? JllBranding: null);
  }

  addJllSiteBrandingFavicon() {
    if(this.isJllSite()) {
      let faviconSizes = {
        small: '17x17',
        medium: '33x33',
        large: '98x97',
      };
      for(let faviconSizeValue in faviconSizes) {
        let link = (<any>document.getElementById('favicon-'+faviconSizeValue));
        if(link) {
          link.type = 'image/png';
          link.rel = 'shortcut icon';
          link.sizes = faviconSizes[faviconSizeValue];
          link.href = 'assets/images/capsule_logo_jll_red_' +link.sizes+ '.png';
        }
      }  
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/branding.service.ts